import React from 'react';
import { bonus } from 'static/icons/resizable';
import { Icon, Text } from 'view/atoms';
import * as S from './CardBar.styles';

type ICardBarProps = {
  title: string;
  type: string;
  sizeMin: number;
  sizeMax: number;
  cardBarBgColor?: string;
};

export const CardBar = ({
  title,
  type,
  sizeMin,
  sizeMax,
  cardBarBgColor,
}: ICardBarProps) => {
  const sizeRangeEnd =
    sizeMin === sizeMax || sizeMax === undefined ? '' : `-${sizeMax}`;

  const discountSize = !sizeMin ? undefined : `${sizeMin}${sizeRangeEnd}%`;

  return (
    <S.CardBar cardBarBgColor={cardBarBgColor}>
      <S.CardBarSection>
        <S.CardHeader>
          <Text kind='h4' length={title?.length}>
            {title}
          </Text>
        </S.CardHeader>
        <Text kind='small1' color='gray2' length={type?.length}>
          {type}
        </Text>
      </S.CardBarSection>

      {discountSize ? (
        <S.DiscountTextWrapper>
          <Text kind='h3'>{discountSize}</Text>
        </S.DiscountTextWrapper>
      ) : (
        <Icon src={bonus} alt='Bonus icon' />
      )}
    </S.CardBar>
  );
};
